import React, { useState } from 'react';
import { X, MessageCircle, Send } from 'lucide-react';
import { companyInfo } from '../mock';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  // Format phone number for WhatsApp (remove spaces and add country code)
  const whatsappNumber = '905432026363'; // 0543 202 63 63 -> +90 543 202 63 63

  const quickMessages = [
    'Merhaba, ürünleriniz hakkında bilgi almak istiyorum.',
    'Fiyat listesi alabilir miyim?',
    'Satış noktalarınızı öğrenmek istiyorum.',
    'Toptan satış yapıyor musunuz?'
  ];

  const sendWhatsAppMessage = (text) => {
    const encodedMessage = encodeURIComponent(text);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
    setIsOpen(false);
    setMessage('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim()) {
      sendWhatsAppMessage(message);
    }
  };

  return (
    <>
      {/* Chat Box */}
      {isOpen && (
        <div className="fixed bottom-24 right-4 md:right-8 w-80 md:w-96 bg-white rounded-2xl shadow-2xl z-50 animate-slideUp">
          {/* Header */}
          <div className="bg-gradient-to-r from-green-500 to-green-600 p-4 rounded-t-2xl flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="relative">
                <img
                  src="https://customer-assets.emergentagent.com/job_web-collaborator/artifacts/cyb27p3j_Pekala-Sut-Logo.png"
                  alt="Pekala"
                  className="w-12 h-12 rounded-full bg-white p-1"
                />
                <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 border-2 border-white rounded-full"></span>
              </div>
              <div>
                <h3 className="text-white font-bold">Pekala Müşteri Hizmetleri</h3>
                <p className="text-green-100 text-xs">Genellikle birkaç dakika içinde yanıt verir</p>
              </div>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white hover:bg-green-600 p-1 rounded-full transition-colors duration-300"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          {/* Chat Body */}
          <div className="p-4 bg-gradient-to-b from-gray-50 to-white max-h-96 overflow-y-auto">
            {/* Welcome Message */}
            <div className="mb-4">
              <div className="bg-white rounded-lg shadow-sm p-4 border border-gray-200">
                <p className="text-gray-800 text-sm mb-2">
                  👋 Merhaba! Pekala'ya hoş geldiniz.
                </p>
                <p className="text-gray-600 text-xs">
                  Size nasıl yardımcı olabiliriz? Aşağıdaki hızlı mesajlardan birini seçebilir veya kendi mesajınızı yazabilirsiniz.
                </p>
              </div>
            </div>

            {/* Quick Messages */}
            <div className="space-y-2">
              <p className="text-xs text-gray-500 font-medium mb-2">Hızlı Mesajlar:</p>
              {quickMessages.map((msg, index) => (
                <button
                  key={index}
                  onClick={() => sendWhatsAppMessage(msg)}
                  className="w-full text-left p-3 bg-white hover:bg-green-50 border border-gray-200 hover:border-green-300 rounded-lg text-sm text-gray-700 transition-all duration-300 hover:shadow-md"
                >
                  {msg}
                </button>
              ))}
            </div>
          </div>

          {/* Input Form */}
          <form onSubmit={handleSubmit} className="p-4 border-t border-gray-200 bg-white rounded-b-2xl">
            <div className="flex space-x-2">
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Mesajınızı yazın..."
                className="flex-1 px-4 py-2 border border-gray-300 rounded-full focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none text-sm"
              />
              <button
                type="submit"
                disabled={!message.trim()}
                className="bg-gradient-to-r from-green-500 to-green-600 text-white p-2 rounded-full hover:from-green-600 hover:to-green-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <Send className="h-5 w-5" />
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-2 text-center">
              {companyInfo.phone}
            </p>
          </form>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-4 md:right-8 w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 text-white rounded-full shadow-2xl hover:shadow-green-500/50 hover:scale-110 transition-all duration-300 flex items-center justify-center z-50 group"
        aria-label="WhatsApp ile iletişim"
      >
        {isOpen ? (
          <X className="h-7 w-7" />
        ) : (
          <>
            <MessageCircle className="h-7 w-7" />
            <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full animate-pulse"></span>
          </>
        )}
      </button>
    </>
  );
};

export default WhatsAppWidget;
